import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { SharedModule } from '@shared/share.module';
import { MyAppsComponent } from './my-apps.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: MyAppsComponent,
        outlet: 'dashboard',
      },
    ],
  },
];

@NgModule({
  declarations: [MyAppsComponent],
  imports: [CommonModule, SharedModule, PipesModule, RouterModule.forChild(routes)],
})
export class MyAppsModule {}
